import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import {
  UserProfile,
  IUserLine,
} from './states'
import UserProfileState from './states'
import _ from 'lodash'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<UserProfileState> = {
  [mutationType.GET_USER_PROFILE](state: UserProfileState, data: UserProfile): void {
    state.profile = {...state.profile, ...data }
  },
  [mutationType.GET_USER_LINE](state: UserProfileState, data: IUserLine): void {
    state.line = {...state.profile, ...data }
  },
  [mutationType.SET_USER_META_DATA](state: UserProfileState, data: UserProfile['metadata']['excludeDate']): void {
   state.profile = {...state.profile, metadata: {...state.profile[`metadata`], ...data}}
  },
  [mutationType.REMOVE_USER_META_DATA](state: UserProfileState, data: UserProfile['metadata']['excludeDate']): void {
   state.profile = {...state.profile, metadata: {...state.profile[`metadata`], ...data}}
  },
  [mutationType.PUT_USER](state: UserProfileState, data: UserProfile): void {
   state.profile = { ...state.profile, ...data }
  },
  [mutationType.SET_LINE_ID](state: UserProfileState, lineId: string): void {
   state.line.userId = lineId
  },
}

export default mutations
